import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'Dashboard',
        icon: 'bx-home-circle',
        link: '/dashboard',
        subItems: [
            {
                id: 1,
                parentId: 1,
                label: 'Analytics',
                link: '/dashboard'
            },
            {
                id: 2,
                parentId: 1,
                label: 'Overview',
                link: '/dashboard/overview'
            },
            {
                id: 3,
                parentId: 1,
                label: 'Notification Monitoring',
                link: '/dashboard/notification-monitoring'
            }
        ]
    },
    {
        id: 2,
        label: 'Banner',
        icon: 'bx-briefcase-alt',
        link: '/banner',
        subItems: [
            {
                id: 1,
                parentId: 2,
                label: 'Banner',
                link: '/banner'
            },
            {
                id: 2,
                parentId: 2,
                label: 'Pills',
                link: '/banner/pills'
            },
            {
                id: 3,
                parentId: 2,
                label: 'Shorts',
                link: '/banner/shorts'
            }
          ]
    },
    // {
    //     id: 3,
    //     label: 'Quiz',
    //     icon: 'bx-store',
    //     subItems: [
    //       {
    //         id: 1,
    //         parentId: 3,
    //         label: 'Common Quiz',
    //         link: '/quiz/common-quiz'
    //       },
    //         {
    //             id: 2,
    //             parentId: 3,
    //             label: 'Add',
    //             link: '/quiz/add'
    //         },
    //         {
    //             id: 3,
    //             parentId: 3,
    //             label: 'List',
    //             link: '/quiz/list'
    //         },
    //         {
    //             id: 4,
    //             parentId: 3,
    //             label: 'Undeclared Matches',
    //             link: '/quiz/undeclared-match'
    //         },
    //         {
    //             id: 5,
    //             parentId: 3,
    //             label: 'Results',
    //             link: '/quiz/results'
    //         }
    //     ]
    // },
    {
        id: 4,
        label: 'Api Syncing',
        icon: 'bx-sync',
        subItems: [
            {
                id: 1,
                parentId: 4,
                label: 'Updates',
                link: '/admin/updates'
            },
            {
                id: 2,
                parentId: 4,
                label: 'Series',
                link: '/admin/series'
            },
            {
                id: 3,
                parentId: 4,
                label: 'Matches',
                link: '/admin/match'
            },
            {
                id: 4,
                parentId: 4,
                label: 'Series News',
                link: '/admin/series-news'
            },
            {
                id: 5,
                parentId: 4,
                label: 'Match News',
                link: '/admin/match-news'
            },
        ]
    },
    {
        id: 5,
        label: 'Contest',
        icon: 'question-mark',
        subItems: [
            {
                id: 1,
                parentId: 5,
                label: 'Question',
                link: '/contests/question'
            },
            {
                id: 2,
                parentId: 5,
                label: 'Ans Question',
                link: '/contests/ans-question'
            },
            {
                id: 3,
                parentId: 5,
                label: 'User Transanction',
                link: '/contests/user-transanction'
            },
        ]
    },
    {
        id: 6,
        label: 'Ecommerce',
        icon: 'shopping-bag',
        subItems: [
            {
                id: 1,
                parentId: 6,
                label: 'Product',
                link: '/ecommerce'
            },
            {
                id: 2,
                parentId: 6,
                label: 'Create Product',
                link: '/ecommerce/create-product'
            },
            {
                id: 3,
                parentId: 6,
                label: 'Orders',
                link: '/ecommerce/orders'
            },
        ]
    },
    {
        id: 7,
        label: 'Users',
        icon: 'user',
        link: '/users',
        subItems: [
            {
                id: 1,
                parentId: 7,
                label: 'Users',
                link: '/users'
            },
            {
                id: 2,
                parentId: 7,
                label: 'Notification',
                link: '/users/notification'
            },
            {
                id: 3,
                parentId: 7,
                label: 'Wallet Stats',
                link: '/users/wallet-stats'
            }
        ]
    },
    {
        id: 8,
        label: 'Polls',
        icon: 'bx-poll',
        subItems: [
            {
                id: 1,
                parentId: 8,
                label: 'Question',
                link: '/polls/questions'
            },
            {
                id: 2,
                parentId: 8,
                label: 'Declare Result',
                link: '/polls/results'
            }
        ]
    },
    {
        id: 9,
        label: 'AI Insight',
        icon: 'bx-bulb',
        subItems: [
            {
                id: 1,
                parentId: 9,
                label: 'Match Insights',
                link: '/ai-insight/match-insights'
            }
        ]
    },
    {
        id: 10,
        label: 'Settings',
        icon: 'bx-cog',
        subItems: [
            {
                id: 1,
                parentId: 10,
                label: 'Manual Sync',
                link: '/settings/manual-sync'
            },
            {
                id: 2,
                parentId: 10,
                label: 'Configure Updates',
                link: '/settings/app-version'
            },
            {
                id: 3,
                parentId: 10,
                label: 'Ads Configuration',
                link: '/settings/ads-config'
            },
            {
                id: 4,
                parentId: 10,
                label: 'LLM Settings',
                link: '/settings/llm-settings'
            }
        ]
    }
]
